<div class="pagination-container">
    <button mat-stroked-button (click)="onNextClick()" [disabled]="!afters.length">Load more</button>
    <p class="pagination-info">Showing {{meta.to}} / {{meta.total}}</p>
</div>

